import { schema } from 'normalizr';

const quizOptionSchema = new schema.Entity('quizOptions', {});

export default quizOptionSchema;
